import * as RadixDialog from "@radix-ui/react-dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { Close } from "../../../assets/svgCompopnent/Close";
import { ProgressBar } from "../../ProgressBar";
import { useEffect, useState } from "react";
import styles from "./CashingMaterials.module.scss";
import { useAppSelector } from "../../../utils/hooks";
import { getActiveCollectionAssetId } from "../../../redux/selectors/ui.selector";
import { formatSecondsToMinutes } from "../../../utils/supportUtils";

interface CashingMaterialsModalPropsI {
  isOpen: boolean;
  setOpen: (value: boolean) => void;
}

const CashingMaterialsModal: React.FC<CashingMaterialsModalPropsI> = ({ isOpen, setOpen }) => {
  const [progress, setProgress] = useState(0);
  const [expectedTime, setExpectedTime] = useState("0");
  const [isDisabledBtn, setIsDisabledBtn] = useState(false);
  const [materialsCount, setMaterialsCount] = useState(0);
  const [isFinished, setIsFinished] = useState(false);
  const assetId = useAppSelector(getActiveCollectionAssetId);
  const preloadMaterials = async () => {
    // const config = {
    //   assetId: assetId,
    //   environment: "admin-fts",
    //   baseUrl: "https://admin-fts.threekit.com",
    //   admin: {
    //     token: "a3d1f8d7-9e6d-46f2-a612-d6967a5a554f",
    //     type: "Bearer",
    //   },
    //   preview: {
    //     baseUrl: "https://preview.threekit.com",
    //     token: "4a5ef3dc-17e9-47c8-b101-b260edb37619",
    //     type: "Bearer",
    //   },
    //   cache: {
    //     name: "api-cache-v1", // название кэша, должен совпадать с SW
    //   },
    // };

    // const loader = new APITextureLoader(config, true); // true = использовать preview среду

    try {
      const attributes = window.configurator.getDisplayAttributes();

      for (const attr of attributes) {
        if (attr.type === "Asset" && attr.name === "Materials") {
          setIsDisabledBtn(true);
          for (const val of attr.values) {
            const currIndex = attr.values.findIndex((i: any) => i.assetId === val.assetId);
            // console.log("Progress:",`${currIndex} of ${materials.length}`);
            await window.configurator.setConfiguration({ Materials: { assetId: val.assetId } });
            setProgress(Math.round(((currIndex + 1) / attr.values.length) * 100));
          }
          sessionStorage.setItem("materialsCached", "true");
          setIsDisabledBtn(false);
          setIsFinished(true);
          console.log(`✅ Preloaded ${attr.values.length} materials!`);
        }
      }

      // loader.addProgressListener((assetType: any, data: { current: any; total: any; status: any }) => {
      //   console.log(`[${assetType}] ${data.current}/${data.total} - ${data.status}`);
      // });
      // await loader.loadTexturesEfficiently();
    } catch {
      sessionStorage.setItem("materialsCached", "false");
      setIsDisabledBtn(false);
      setIsFinished(false);
    }
  };

  useEffect(() => {
    if (window.configurator) {
      const attributes = window.configurator.getDisplayAttributes();
      for (const attr of attributes) {
        if (attr.type === "Asset" && attr.name === "Materials") {
          setExpectedTime((attr.values.length * 2.5).toFixed(0));
          setMaterialsCount(attr.values.length);
        }
      }
    }
  }, []);

  return (
    <RadixDialog.Root open={isOpen} onOpenChange={setOpen}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className={styles.dialogOverlay} />
        <RadixDialog.Content className={styles.dialogContent}>
          <VisuallyHidden.Root>
            <RadixDialog.Title>Email modal</RadixDialog.Title>
          </VisuallyHidden.Root>
          <RadixDialog.Close asChild>
            <button onClick={() => setOpen(false)} className={styles.closeButton} aria-label="Close">
              <Close />
            </button>
          </RadixDialog.Close>
          <h2 className={styles.dialogTitle}>Materials Caching</h2>
          <p className={styles.infoText}>
            To start caching materials in your browser session, please click the button below. Number of materials:
            <strong>{materialsCount}</strong>. Expected time for process:{" "}
            <strong>{formatSecondsToMinutes(expectedTime)}</strong> seconds.
          </p>
          <ProgressBar className={styles.progressBar} value={progress} />
          <div className={styles.linkSection}>
            {!isFinished && (
              <button disabled={isDisabledBtn} onClick={preloadMaterials} className={styles.startBtn}>
                Start Cashing
              </button>
            )}
            {isFinished && (
              <button disabled={isDisabledBtn} onClick={() => setOpen(false)} className={styles.startBtn}>
                Close
              </button>
            )}
          </div>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
};

export default CashingMaterialsModal;
